<div class="progress-circle" [style.width.px]="size" [style.height.px]="size">
  <svg [attr.viewBox]="'0 0 ' + size + ' ' + size" [attr.width]="size" [attr.height]="size">
    <!-- Background circle -->
    <circle
      fill="none"
      [attr.cx]="center"
      [attr.cy]="center"
      [attr.r]="radius"
      [attr.stroke-width]="strokeWidth"
      stroke="#ececec"
    ></circle>
    <!-- Foreground circle -->
    <circle
      fill="none"
      [attr.cx]="center"
      [attr.cy]="center"
      [attr.r]="radius"
      [attr.stroke-width]="strokeWidth"
      [attr.stroke]="color"
      stroke-linecap="round"
      [attr.stroke-dasharray]="circumference"
      [attr.stroke-dashoffset]="offset"
      [style.transform]="'rotate(-90deg)'"
      [style.transform-origin]="center + 'px ' + center + 'px'"
      [style.transition]="'stroke-dashoffset 0.6s ease'"
    ></circle>
    <!-- Percentage text -->
    <text
      [attr.x]="center"
      [attr.y]="center - 4"
      text-anchor="middle"
      dominant-baseline="middle"
      [attr.fill]="color"
      font-size="16"
      font-weight="700"
    >{{ percentage }}%</text>
    <!-- Label text -->
    <text
      *ngIf="label"
      [attr.x]="center"
      [attr.y]="center + 12"
      text-anchor="middle"
      dominant-baseline="middle"
      fill="#4a4a4a"
      font-size="8"
    >{{ label }}</text>
  </svg>
</div>
